export default __webpack_public_path__ + "static/media/account-minus.2d95ea08.svg";